module.exports = __webpack_public_path__ + "static/media/bracket_post_insulator.98c96dac.webp";